import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeImageReportSundry } from './Pages';

export const EmployeeImageReportSundryRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeImageReportSundry} />
    </Fragment>
)